import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PersonalInfoComponent } from './components/personal-info/personal-info.component';
import { ContactInfoComponent } from './components/contact-info/contact-info.component';
import { LegitimationInfoComponent } from './components/legitimation-info/legitimation-info.component';
import { BankInfoComponent } from './components/bank-info/bank-info.component';
import { FinancialInfoComponent } from './components/financial-info/financial-info.component';
import { ProductSelectionComponent } from './components/product-selection/product-selection.component';
import { ServiceInfoComponent } from './components/service-info/service-info.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { SummaryComponent } from './components/summary/summary.component';
import { SigningComponent } from './components/signing/signing.component';
import { HomeComponent } from './components/home/home.component';
import { ResultComponent } from './components/result/result.component';
import { AuthGuard } from './auth.guard';
import { GuaranteeUploadComponent } from './components/guarantee-upload/guarantee-upload.component';
import { PreviewComponent } from './components/preview/preview.component';
import { PrimarySigningComponent } from './components/primary-signing/primary-signing.component';
import { BasicInfoComponent } from './components/basic-info/basic-info.component';
import { LandingComponent } from './pages/components/landing/landing.component';
import { PersonalDataState } from './state/personal-data.state';
import { provideStates } from '@ngxs/store';
import { CustomerSearchComponent } from './pages/components/customer-search/customer-search.component';
import { SuccessComponent } from './pages/components/success/success.component';
import { RejectionComponent } from './pages/components/rejection/rejection.component';
import { AppState } from './states/AppState';
import { BankInfoState } from './states/BankInfoState';
import { BasicInfoState } from './states/BasicInfoState';
import { ContactInfoState } from './states/ContactInfoState';
import { CurrentApplicationState } from './states/CurrentApplicationState';
import { CurrentErrorState } from './states/CurrentErrorState';
import { FinancialInfoState } from './states/FinancialInfoState';
import { LegitimationInfoState } from './states/LegitimationInfoState';
import { PaymentInfoState } from './states/PaymentInfoState';
import { PersonalInfoState } from './states/PersonalInfoState';
import { SelectedProductState } from './states/SelectedProductState';
import { ServiceInfoState } from './states/ServiceInfoState';

export enum AppRoutes {
  MAIN = 'main',
  FLOW = 'flow',
  SUCCESS = 'success',
  REJECTION = 'rejected',
  OVERVIEW = 'overview',

}

export enum AppRoutesFlow {
  CUSTOMER_SEARCH = 'customer-search',
  CHANGE_ADDRESS = 'change-address',
  CHANGE_PHONENUMBER = 'change-contact',
  CHANGE_EMAIL = 'change-email',
  CHANGE_NAME = 'change-name',
  DOCUMENT_UPLOAD = 'document-upload',
}


const STATES = [
  //General States
  PersonalDataState,
   CurrentErrorState,
              PersonalInfoState,
              ContactInfoState,
              LegitimationInfoState,
              BankInfoState,
              FinancialInfoState,
              SelectedProductState,
              PaymentInfoState,
              BasicInfoState,
              ServiceInfoState,
              CurrentApplicationState,
              AppState,
];


const routes: Routes = [
  {
    path: 'guarantee-upload',
    component: GuaranteeUploadComponent,
    canActivate: [AuthGuard],
    providers: [provideStates(STATES)],
  },
  {
    path: 'product-selection',
    component: ProductSelectionComponent,
    canActivate: [AuthGuard],
      providers: [provideStates(STATES)],
  },
  {
    path: 'personal-info',
    component: PersonalInfoComponent,
    canActivate: [AuthGuard],
      providers: [provideStates(STATES)],
  },
  {
    path: 'contact-info',
    component: ContactInfoComponent,
    canActivate: [AuthGuard],
      providers: [provideStates(STATES)],
  },
  {
    path: 'legitimation-info',
    component: LegitimationInfoComponent,
    canActivate: [AuthGuard],
      providers: [provideStates(STATES)],
  },
  {
    path: 'bank-info',
    component: BankInfoComponent,
    canActivate: [AuthGuard],
      providers: [provideStates(STATES)],
  },
  {
    path: 'financial-info',
    component: FinancialInfoComponent,
    canActivate: [AuthGuard],
      providers: [provideStates(STATES)],
  },
  {
    path: 'basic-info',
    component: BasicInfoComponent,
    canActivate: [AuthGuard],
      providers: [provideStates(STATES)],
  },
  {
    path: 'service-info',
    component: ServiceInfoComponent,
    canActivate: [AuthGuard],
      providers: [provideStates(STATES)],
  },
  {
    path: 'file-upload',
    component: FileUploadComponent,
    canActivate: [AuthGuard],
      providers: [provideStates(STATES)],
  },
  {
    path: 'summary',
    component: SummaryComponent,
    canActivate: [AuthGuard],
      providers: [provideStates(STATES)],
  },
  {
    path: 'preview',
    component: PreviewComponent,
    canActivate: [AuthGuard],
      providers: [provideStates(STATES)],
  },
  {
    path: 'signing',
    component: SigningComponent,
    canActivate: [AuthGuard],
      providers: [provideStates(STATES)],
  },
  {
    path: 'primary-signing',
    component: PrimarySigningComponent,
    canActivate: [AuthGuard],
      providers: [provideStates(STATES)],
  },
  {
    path: 'result',
    component: ResultComponent,
    canActivate: [AuthGuard],
      providers: [provideStates(STATES)],
  },
  {
     path: 'customer-search',
    component: CustomerSearchComponent,
    canActivate: [AuthGuard],
      providers: [provideStates(STATES)],
  },
  {
     path: 'overview',
    component: LandingComponent,
    canActivate: [AuthGuard],
      providers: [provideStates(STATES)],
  },
  {
    path: AppRoutes.FLOW,
    loadChildren: () =>
      import('./pages/flow/flow.routes').then(
        (routes) => routes.flowRoutes
      ),
    canActivate: [AuthGuard],
    providers: [provideStates(STATES), AuthGuard],
  },
  {
      path: AppRoutes.SUCCESS,
    component: SuccessComponent,
    canActivate: [AuthGuard],
      providers: [provideStates(STATES)],
  },
   {
      path: AppRoutes.REJECTION,
    component: RejectionComponent,
    canActivate: [AuthGuard],
      providers: [provideStates(STATES)],
  },
  // {
  //   path: 'landing',
  //   component: LandingComponent,
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'change-address',
  //   component: ChangeAddressComponent,
  //   canActivate: [AuthGuard],
  // },
  { path: '', component: HomeComponent, canActivate: [AuthGuard],  providers: [provideStates(STATES)], },
  { path: '**', component: HomeComponent, canActivate: [AuthGuard],  providers: [provideStates(STATES)], },
  // {
  //   path: 'landing',
  //   component: LandingComponent,
  // },
  // {
  //   path: AppRoutesFlow.CHANGE_ADDRESS,
  //   component: ChangeAddressComponent,
  //   canActivate: [AuthGuard],
  // },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
